


export enum SelectReasonType {
	planningReason = 'planningReason',
	executionReason = 'executionReason',
}